/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Drag to resize the panel',
  command_intelligence_close_aria: 'Close assistant',
  command_intelligence_send_aria: 'Send message',
  command_intelligence_stop_aria: 'Stop response',
  command_intelligence_composer_input_aria: 'Message to Command Intelligence',
  command_intelligence_drawer_more_options: 'More options',
  command_intelligence_dock_position: 'Dock position',
  command_intelligence_dock_left: 'Left',
  command_intelligence_dock_right: 'Right',
  command_intelligence_dock_top: 'Top',
  command_intelligence_dock_bottom: 'Bottom',
  command_intelligence_panel_layout: 'Panel layout',
  command_intelligence_panel_layout_overlap: 'Overlap content',
  command_intelligence_panel_layout_push: 'Push content',
  command_intelligence_panel_auto_hide_overlap: 'Auto-hide when clicking outside',
  command_intelligence_session_reset: 'Reset conversation',
  command_intelligence_try_one_of_these: 'Try one of these',
  command_intelligence_attach_hint: 'Attach context items to start asking questions.',
  command_intelligence_attach_modal_title: 'Attach context',
  command_intelligence_attach_modal_subtitle: 'Pick from items in this view. Already attached items are greyed out.',
  command_intelligence_attach_modal_search_placeholder: 'Search…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# item available} other {# items available}} · {selected} selected',
  command_intelligence_attach_modal_empty: 'Nothing available to attach',
  command_intelligence_attach_modal_no_results: 'No items match your search',
  command_intelligence_context_bar_attached_section: 'Attached ({count})',
  command_intelligence_context_bar_clear_attached: 'Clear',
  command_intelligence_context_bar_add: 'Attach context',
  command_intelligence_placeholder_ready: 'Ask a question…',
  command_intelligence_placeholder_attach: 'Attach context to ask a question…',
  command_intelligence_composer_submit_hint: 'Enter to send · Shift+Enter for new line',
  command_intelligence_composer_stop_hint: 'Stop · draft your next message while waiting',
  command_intelligence_response_stopped: 'Response stopped',
  command_intelligence_generation_in_progress: 'Working on your question',
  command_intelligence_generation_trace_title: 'Steps taken',
  command_intelligence_generation_trace_toggle: 'Show steps',
  command_intelligence_generation_trace_summary: '{completed} of {total} steps completed',
  command_intelligence_generation_trace_summary_generic: 'Generation steps',
  command_intelligence_generation_tool_count: '{count, plural, one {# tool} other {# tools}}',
  command_intelligence_generation_turn_label: 'Turn {turn} of {total}',
  command_intelligence_generation_turn_completed: 'Completed turn {turn} of {total}',
  command_intelligence_generation_turn_completed_elapsed: 'Completed turn {turn} of {total} ({seconds}s elapsed)',
  command_intelligence_generation_turn_completed_with_tools: 'Completed turn {turn} of {total} - used {tools}',
  command_intelligence_generation_tools_used: 'Used {tools}',
  command_intelligence_reasoning_thinking: 'Thinking…',
  command_intelligence_reasoning_thought_for_seconds: 'Thought for {seconds} seconds',
  command_intelligence_reasoning_waiting: 'Working on your question…',
  command_intelligence_attach_modal_done: 'Done',
  command_intelligence_attach_modal_attached_badge: 'attached',
  command_intelligence_attach_modal_attach: 'Attach',
  command_intelligence_attach_modal_attach_count: 'Attach ({count})',
  command_intelligence_attach_modal_close_aria: 'Close picker',
  command_intelligence_session_limit_context: 'Context limit reached. Reset the conversation to continue.',
  command_intelligence_session_limit_prompt: 'Message limit reached. Reset the conversation to continue.',
  command_intelligence_suggested_followups: 'Suggested follow-ups',
  command_intelligence_credit_warning_line: '{pct}% of {scope} monthly AI credits used',
  command_intelligence_tooltip_prompts: '{count} of {max} messages ({pct}%)',
  command_intelligence_tooltip_context: '{used} of {max} context tokens ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Context usage appears after the first reply',
  command_intelligence_credits_loading: 'Loading credits…',
  command_intelligence_credits_unavailable: 'Credits unavailable',
  command_intelligence_credits_tooltip: 'Monthly AI credits for {monthKey}',
  command_intelligence_credits_tooltip_short: 'Monthly AI credits',
  command_intelligence_credits_scope_profile: 'Profile',
  command_intelligence_credits_scope_entity: 'Entity',
  command_intelligence_credits_used_of_cap: '{used} of {cap} credits',
  command_intelligence_credits_used_no_cap: '{used} credits used',
  command_intelligence_credits_monthly_title: 'Monthly AI credits',
  command_intelligence_compare_aria: 'Compare agents',
  command_intelligence_compare_tooltip: 'Run the same question against multiple agent profiles',
  command_intelligence_compare_cancelled: 'Comparison cancelled',
  command_intelligence_compare_branch_failed: 'Comparison branch failed',
  command_intelligence_compare_title: 'Agent comparison',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} in / {outTok} out · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Good response',
  command_intelligence_feedback_bad_response: 'Bad response',
  command_intelligence_feedback_dialog_title: 'Provide feedback',
  command_intelligence_feedback_dialog_body:
    'Help us improve by providing feedback on this response. Your feedback will be sent to our operations team.',
  command_intelligence_feedback_response_label: 'Response',
  command_intelligence_feedback_input_label: 'Your feedback (optional)',
  command_intelligence_feedback_input_placeholder: 'What was wrong or unhelpful about this response?',
  command_intelligence_feedback_submit: 'Submit feedback',
  command_intelligence_feedback_submit_error: 'Failed to submit feedback. Please try again.',
  command_intelligence_feedback_question_understanding: 'Did the agent understand what you wanted?',
  command_intelligence_feedback_question_readability: 'Was the response easy to read and use?',
  command_intelligence_feedback_section_understanding: 'Understanding',
  command_intelligence_feedback_section_readability: 'Readability',
  command_intelligence_feedback_choice_none: 'None',
  command_intelligence_feedback_choice_misunderstood_task: 'Misunderstood task',
  command_intelligence_feedback_choice_ignored_constraint: 'Ignored constraint',
  command_intelligence_feedback_choice_wrong_scope: 'Wrong scope',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Visually hard to read',
  command_intelligence_feedback_choice_wrote_too_much: 'Wrote too much',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Explanation not trustworthy',
  command_intelligence_copy_aria: 'Copy to clipboard',
  command_intelligence_error_missing_invoke_permission:
    'You do not have permission to use Command Intelligence for this agent. Ask your administrator to grant the required Intelligence permissions (for example, analyst).',
  command_intelligence_access_denied_title: 'Access required',
  command_intelligence_error_session_expired: 'Your session has expired. Please refresh the page and sign in again.',
};
